import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId, startDate, endDate) => {
  const endpoint = URLS.venue.classtivitySchedules(venueId, startDate, endDate);

  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.CLASSTIVITY_SCHEDULES', handler, { defaultKey: [1, 2, 3] });
